






































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import { required, minLength } from 'vuelidate/lib/validators';

import QCard from '@/components/Queue/QCard.vue';

import AdmitIcon from '@/components/Icons/Admit.vue';
import CloseIcon from '@/components/Icons/Close.vue';
import PlusIcon from '@/components/Icons/Plus.vue';
import TransferIcon from '@/components/Icons/Transfer.vue';

export default Vue.extend({
  name: 'queue-form',
  components: {
    QCard,
    AdmitIcon,
    CloseIcon,
    PlusIcon,
    TransferIcon,
  },
  data() {
    return {
      es: true,
      activePage: '',
      submitted: false,
      queueForm: {
        accCode: '',
      },
      validEntrances: [
        {
          id: 1,
          name: 'Entrance 1',
        },
        {
          id: 2,
          name: 'Entrance 2',
        },
        {
          id: 3,
          name: 'Entrance 3',
        },
        {
          id: 4,
          name: 'Entrance 4',
        },
        {
          id: 5,
          name: 'Entrance 5',
        },
      ],
      reservations: [
        {
          id: 1,
          name: '2582',
        },
        {
          id: 2,
          name: '2583',
        },
        {
          id: 3,
          name: '2584',
        },
        {
          id: 4,
          name: '2585',
        },
        {
          id: 5,
          name: '2586',
        },
        {
          id: 6,
          name: '2587',
        },
        {
          id: 7,
          name: '2588',
        },
        {
          id: 8,
          name: '2589',
        },
        {
          id: 9,
          name: '2590',
        },
        {
          id: 10,
          name: '2591',
        },
        {
          id: 11,
          name: '2592',
        },
        {
          id: 12,
          name: '2593',
        },
        {
          id: 13,
          name: '2594',
        },
        {
          id: 14,
          name: '2595',
        },
        {
          id: 15,
          name: '2596',
        },
        {
          id: 16,
          name: '2597',
        },
        {
          id: 17,
          name: '2598',
        },
        {
          id: 18,
          name: '2599',
        },
      ],
    };
  },
  props: {},
  validations: {
    queueForm: {
      accCode: { required },
    },
  },
  methods: {
    changePage(newPage: string) {
      (this as any).activePage = newPage;
    },
    handleSubmit() {
      // Submit form
    },
  },
  created() {
    (this as any).activePage = 'login';
  },
});
